/* eslint-disable jsx-a11y/alt-text */
import "../styles/componentStyles/IntroUIComponent.scss";
import cn from "../languages/cn";
import { useEffect, useState } from "react";
import { PrivacyPolicyComponent } from "./PrivacyPolicyComponent";
import { trackOpenPrivacy } from "../webar-core/framework/utils/gtag";
/**
 * Intro Screen UI
 * @returns
 */
export function IntroUIComponent(props: any) {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [hideIntroUI, setHideIntroUI] = useState(false);

  const showIntroUI = setTimeout(() => {
    document.querySelector("#loadingScreen")!.classList.add("animateIn");
  }, 2000);

  return (
    <div className="absolute-fill loadingContainer">
      <div id="loadingScreen" className={`${hideIntroUI ? "hidden" : ""}`}>
        <img
          id="logoBKG"
          src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/loadingPage/8thwallLogo.png"
        />
        <img
          id="logo"
          src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/loadingPage/RPRLogo.png"
        />
        <img
          id="clientLogo"
          src="https://rpr-cdn.s3.us-west-1.amazonaws.com/glenlivet/assets/assets/ui/loadingPage/glenlivetLogo.png"
        />

        <div id="sampleRoom">
          {props.translate ? cn.sampleRoom.text : "Sample Room"}
        </div>
        <div
          id="privacyPolicy"
          onClick={() => {
            clearInterval(showIntroUI);
            clearInterval(props.endIntroScreen);
            setHideIntroUI(true);
            setTimeout(() => {
              trackOpenPrivacy();
              setShowPrivacyPolicy(true);
            }, 500);
          }}
        >
          {props.translate ? cn.privacyPolicy.text : "Privacy Policy"}
        </div>
      </div>
      <PrivacyPolicyComponent
        showPrivacyPolicy={showPrivacyPolicy}
        setPrivacyStay={props.setEnabled}
      ></PrivacyPolicyComponent>
    </div>
  );
}
